import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationScanCreateArgs, Scan } from "types/generated";

export const SCAN_CREATE: TypedDocumentNode<
  { scanCreate: Pick<Scan, "id"> },
  MutationScanCreateArgs
> = gql`
  mutation ScanCreate($input: ScanInput!) {
    scanCreate(input: $input) {
      id
    }
  }
`;
